// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .app-listing-filter-field .custom-ngx-slider .ngx-slider .ngx-slider-bar {
  background: #f8f9fa;
  height: 4px;
  border-radius: 2px;
}
::ng-deep .app-listing-filter-field .custom-ngx-slider .ngx-slider .ngx-slider-selection {
  background: #d4af37 !important;
  border-radius: 1px;
}
::ng-deep .app-listing-filter-field .custom-ngx-slider .ngx-slider .ngx-slider-pointer {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #d4af37;
  border: 2px solid white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}
::ng-deep .app-listing-filter-field .custom-ngx-slider .ngx-slider .ngx-slider-pointer:after {
  display: none;
}
::ng-deep .app-listing-filter-field .custom-ngx-slider .ngx-slider .ngx-slider-bubble {
  background: #333;
  color: white;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 11px;
}
::ng-deep .app-listing-filter-field .custom-ngx-slider .ngx-slider .ngx-slider-limit {
  color: #666;
  font-size: 11px;
}
::ng-deep .app-listing-filter-field .custom-ngx-slider .ngx-slider .ngx-slider-tick {
  width: 1px;
  height: 6px;
  background: #ddd;
}
::ng-deep .app-listing-filter-field .custom-ngx-slider .ngx-slider .ngx-slider-tick.ngx-slider-selected {
  background: #d4af37;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/listing-browse-ui/ngslider.scss"],"names":[],"mappings":"AACE;EACE,mBAAA;EACA,WAAA;EACA,kBAAA;AAAJ;AAGE;EACE,8BAAA;EACA,kBAAA;AADJ;AAIE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yCAAA;AAFJ;AAKE;EACE,aAAA;AAHJ;AAME;EACE,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAJJ;AAOE;EACE,WAAA;EACA,eAAA;AALJ;AAQE;EACE,UAAA;EACA,WAAA;EACA,gBAAA;AANJ;AASE;EACE,mBAAA;AAPJ","sourcesContent":["::ng-deep {\n  .app-listing-filter-field .custom-ngx-slider .ngx-slider .ngx-slider-bar {\n    background: #f8f9fa;\n    height: 4px;\n    border-radius: 2px;\n  }\n\n  .app-listing-filter-field .custom-ngx-slider .ngx-slider .ngx-slider-selection {\n    background: #d4af37 !important;\n    border-radius: 1px;\n  }\n\n  .app-listing-filter-field .custom-ngx-slider .ngx-slider .ngx-slider-pointer {\n    width: 16px;\n    height: 16px;\n    border-radius: 50%;\n    background: #d4af37;\n    border: 2px solid white;\n    box-shadow: 0 2px 6px rgba(0,0,0,0.15);\n  }\n\n  .app-listing-filter-field .custom-ngx-slider .ngx-slider .ngx-slider-pointer:after {\n    display: none;\n  }\n\n  .app-listing-filter-field .custom-ngx-slider .ngx-slider .ngx-slider-bubble {\n    background: #333;\n    color: white;\n    border-radius: 4px;\n    padding: 4px 8px;\n    font-size: 11px;\n  }\n\n  .app-listing-filter-field .custom-ngx-slider .ngx-slider .ngx-slider-limit {\n    color: #666;\n    font-size: 11px;\n  }\n\n  .app-listing-filter-field .custom-ngx-slider .ngx-slider .ngx-slider-tick {\n    width: 1px;\n    height: 6px;\n    background: #ddd;\n  }\n\n  .app-listing-filter-field .custom-ngx-slider .ngx-slider .ngx-slider-tick.ngx-slider-selected {\n    background: #d4af37;\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
